import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { localizedPath } from '../utils/languageUtils.js';

export function useLocalizedPath() {
    const { i18n } = useTranslation();
    const lang = i18n.language || 'en';

    return useMemo(() => {
        function getPath(key) {
            return localizedPath(key, lang);
        }

        function getBlogPath() {
            return lang === 'en' ? '/blog' : `/blog/${lang}`;
        }

        return {
            home: () => getPath('home'),
            podcast: () => getPath('podcast'),
            prices: () => getPath('prices'),
            features: () => getPath('features'),
            faqs: () => getPath('faqs'),
            compareCredly: () => getPath('compareCredly'),
            compareAccredible: () => getPath('compareAccredible'),
            compareBadgr: () => getPath('compareBadgr'),
            compareAcreditta: () => getPath('compareAcreditta'),
            compareCertifier: () => getPath('compareCertifier'),
            compareHub: () => getPath('compareHub'),
            gg: () => getPath('gg'),
            dc: () => getPath('dc'),
            mc: () => getPath('mc'),
            ob: () => getPath('ob'),
            companies: () => getPath('companies'),
            iee: () => getPath('iee'),
            employability: () => getPath('employability'),
            whiteLabel: () => getPath('whiteLabel'),
            integrations: () => getPath('integrations'),
            learningPaths: () => getPath('learningPaths'),
            team: () => getPath('team'),
            marketing: () => getPath('marketing'),
            signature: () => getPath('signature'),
            massive: () => getPath('massive'),
            verification: () => getPath('verification'),
            designer: () => getPath('designer'),
            campaigns: () => getPath('campaigns'),
            lookup: () => getPath('lookup'),
            skillsGraphs: () => getPath('skillsGraphs'),
            skillsIntelligence: () => getPath('skillsIntelligence'),
            blog: () => getBlogPath(),
            corporateLeads: () => getPath('corporateLeads'),
        };
    }, [lang]);
}
